import React from 'react';

import AddRestrictedActionForm from './AddRestrictedActionForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRoleShowState, useRoleShowActions } from './RoleShowContext';

import styles from './RoleModal.module.scss';

const AddRestrictedActionModal = ({ role }) => {
  const state = useRoleShowState();
  const { closeAddRestrictedActionModal } = useRoleShowActions();

  return (
    <StandardModal
      isOpen={state?.addRestrictedActionModalIsOpen}
      onRequestClose={() => {
        closeAddRestrictedActionModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Add Restricted Action to Role
        </h2>
        <AddRestrictedActionForm role={role} />
      </section>
    </StandardModal>
  );
};

export default AddRestrictedActionModal;
